import Vue from 'vue'
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
  state () {
    return {
      paisMemo: {},
			estadosMemo: {},
    }
  },
	getters: {
		getPaisMemo:(state) => (local) => {
			return state.paisMemo[local]
		},
		getEstadosMemo:(state) => (local) => {
			return state.estadosMemo[local]
		},
		existePais:(state) => (local) => {
			return _.has(state.paisMemo, local)
		},
		existeEstado:(state) => (local) => {
			return _.has(state.estadosMemo, local)
		}
	},
  mutations: {
		setPaisMemo(state, {local, lista}){
			state.paisMemo[local] = lista
		},
		setEstadosMemo(state, {local, lista}){
			state.estadosMemo[local] = lista
		}
  },
	actions:{
		setPaisMemo({commit}, {local, lista}){
			commit('setPaisMemo', {local, lista})
		},
		setEstadosMemo({commit}, {local, lista}){
			commit('setEstadosMemo', {local, lista})
		}
	}
})

export default store;
